function PDPStickyCTA() {
    var waitForElements = setInterval(() => {
      const pageContainer = document.querySelector('body.template-product'); // SELECT A TARGET ELEMENT HERE
      if (typeof ranPDPStickyCTA === 'undefined' && pageContainer) {
        window.ranPDPStickyCTA = true;
        clearInterval(waitForElements);
        // SCOPE CSS
        document.body.classList.add('ti017'); // UPDATE TEST NUMBER 
        insertCTA();
        inserts();
        headerObs();
        window.addEventListener('scroll', function () {
          stickyCTA();
        });
  
      }
    }, 100);
  }
  
  function headerObs() {
    const header = document.querySelector('header#SiteHeader');
    const target = document.querySelector('.ticta');
  
    if (header && target) {
      if (header.classList.contains('site-header--stuck')) {
        target.classList.add('header-fixed');
      } else {
        target.classList.remove('header-fixed');
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            // Check if the header has the 'site-header--stuck' class
            if (header.classList.contains('site-header--stuck')) {
              target.classList.add('header-fixed');
            } else {
              target.classList.remove('header-fixed');
            }
          }
        });
      });
      observer.observe(header, {
        attributes: true
      });
    }
  }
  
  
  
  function stickyCTA() {
    var windowTop = window.scrollY || document.documentElement.scrollTop;
    var button = document.querySelector('.product-single__meta .product-block button.btn.btn--full.add-to-cart');
    var chatbox = document.querySelector('iframe#launcher');
    var ctaElement = document.querySelector('.ticta');
    if (button) {
      var buttonTop = button.getBoundingClientRect().top + window.pageYOffset;
      if (windowTop >= buttonTop) {
        ctaElement.classList.add('active');
        if (chatbox) {
          chatbox.classList.add('act');
        }
      } else {
        ctaElement.classList.remove('active');
        if (chatbox) {
          chatbox.classList.remove('act');
        }
      }
    }
  }
  
  function insertCTA() {
    const button = document.querySelector('.product-single__meta .product-block button.btn.btn--full.add-to-cart');
    let newHtml = `
      <div class="ticta">
        <div class="container">
          <div class="wrapper">
              <div class="thumbs"></div>
              <div class="details">   
                  <div class="vendor"></div>
                  <div class="title"></div>
              </div>
          </div>
          <div class="wrapper">
            <button class="atc"><span class="mb-price"></span>ADD TO CART <span class="list-price"> </span> </button>
          </div>
        </div>
      </div>
      `;
    if (button && button.getAttribute('disabled', 'disabled')) {
      newHtml = `
      <div class="ticta">
        <div class="container">
          <div class="wrapper">
              <div class="thumbs"></div>
              <div class="details">   
                  <div class="vendor"></div>
                  <div class="title"></div>
              </div>
          </div>
          <div class="wrapper">
            <button style="background-color:#62676f;" disabled="disabled" class="atc"><span class="mb-price"></span>SOLD OUT <span class="list-price"> </span> </button>
          </div>
        </div>
      </div>
      `;
    }
    const target = document.querySelector('div#PageContainer');
    if (target) {
      target.insertAdjacentHTML('afterend', newHtml);
    }
  }
  
  function inserts() {
    const firstImage = document.querySelector('.product__thumbs--scroller img');
    if (firstImage) {
      const imageSrc = firstImage.getAttribute('src');
      const newImage = document.createElement('img');
      newImage.setAttribute('src', imageSrc);
      newImage.setAttribute('alt', 'Product Thumbnail');
      const targetElement = document.querySelector('.ticta .thumbs');
      if (targetElement) {
        targetElement.appendChild(newImage);
      }
    }
  
    const vendorElement = document.querySelector('.product-single__vendor');
    const clonedVendor = vendorElement.cloneNode(true);
    const target = document.querySelector('.ticta .details .vendor');
    if (target) {
      target.appendChild(clonedVendor);
    }
  
    const titleElement = document.querySelector('h1.h2.product-single__title');
    const clonedTitleElement = titleElement.cloneNode(true);
    const newTitleElement = document.createElement('h3');
    newTitleElement.innerHTML = clonedTitleElement.innerHTML;
    newTitleElement.classList.add('h2', 'product-single__title');
    const targetTitle = document.querySelector('.ticta .details .title');
    if (targetTitle) {
      targetTitle.appendChild(newTitleElement);
    }
  
    const priceElement = document.querySelector('span[data-product-price]');
    const priceText = priceElement.textContent;
    const setPrice1 = document.createElement('p');
    const setPrice2 = document.createElement('span');
    setPrice1.textContent = priceText;
    setPrice2.textContent = "(" + priceText.trim() + ")";
    const targetPrice = document.querySelector('.ticta .list-price');
    const mbPrice = document.querySelector('.ticta .mb-price');
  
    if (targetPrice && mbPrice) {
      mbPrice.appendChild(setPrice1);
      targetPrice.appendChild(setPrice2);
    }
    //onclick even and tracking
    jQuery('.ticta button.atc').on('click', function () {
      jQuery('.page-content--product .product-block button.btn.btn--full.add-to-cart').trigger('click');

      // Start GA send data collection
      const allvars = document.querySelector('select[name="id"]'); 
      const selectedVar = allvars.options[allvars.selectedIndex];

      // Get the value (variant ID) of the selected option
      const variantId = selectedVar ? selectedVar.value : null;
      const variantNameAndPrice = selectedVar ? selectedVar.innerText.trim() : null; 
      const productId = document.querySelector('form input[name="product-id"]') ? document.querySelector('form input[name="product-id"]').value : null;

      // Ensure the eventData object only contains non-null values
      const eventData = {
        vwo_event_name: "pdp_stickyATC_click",
        productName: titleElement?.innerText.trim() || null,  // Safely access titleElement.innerText, default to null if titleElement is not available
        productId: productId || null,
        variantId: variantId || null,
        variantNameAndPrice: variantNameAndPrice || null
      };

      // Remove any null or undefined values from eventData before sending it
      const filteredEventData = Object.fromEntries(Object.entries(eventData).filter(([key, value]) => value != null));
 
      window.Shopify.analytics.publish("vwo_test_event", {
        ...filteredEventData
      }); 
    });
  
    addSwatchClickEvent();
  }
  
  try {
    if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
      PDPStickyCTA();
    } else {
      document.addEventListener('DOMContentLoaded', PDPStickyCTA);
    }
  } catch (err) {
    const e = {
      dev: 'U02M01M9QG6',
      vwotest: 'XX', // Update VWO Test Number 
      vwodesc: 'B&R-A-Build-PDP-StickyCTA-V1-August2024 - Variation 1', // Example (SST-M-PLP-OptimizationsV1-April2023 | Variation 1)
      type: 'vwo',
      message: err.toString(),
      stack: err.stack,
      source: window.location.href
    };
    const x = new XMLHttpRequest();
    x.open('POST', 'https://us-central1-tixray.cloudfunctions.net/err', !0), x.send(JSON.stringify(e));
  }

  

  function addSwatchClickEvent() {
    const swatchLabels = document.querySelectorAll('.color-swatch.variant__button-label'); 
    swatchLabels.forEach((label) => {
      label.addEventListener('click', function () {
        const newImageSrc = this.getAttribute('primary-img'); // Get the new variant image URL 
        if (newImageSrc) {
          const stickyThumb = document.querySelector('.ticta .thumbs img'); 
          if (stickyThumb) {
            stickyThumb.setAttribute('src', newImageSrc); // Update existing image 
          } else {
            const newThumbImg = document.createElement('img');
            newThumbImg.setAttribute('src', newImageSrc);
            newThumbImg.setAttribute('alt', 'Product Thumbnail');
            document.querySelector('.ticta .thumbs').appendChild(newThumbImg);
          }
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function(){

    addSwatchClickEvent()
  })